import { PagesById } from '../catalogProductsListV2.types';
import {
  PageWindowQuery,
  PageWindowSlot,
  ResolvePageWindowParams,
} from './productsPageWindow.types';

const WINDOW_OFFSETS = [-1, 0, 1, 2];

export const resolvePageWindow = ({
  anchorPage,
  pageSize,
  totalItems,
  isEnabled,
}: ResolvePageWindowParams): PageWindowSlot[] =>
  WINDOW_OFFSETS.map((offset) => {
    const page = anchorPage + offset;

    return { page, isValid: isEnabled && page >= 0 && page * pageSize < totalItems };
  });

const toSlotStatus = (query: PageWindowQuery) => {
  if (query.isError) {
    return 'error';
  }

  if (query.isSuccess) {
    return 'success';
  }

  return 'loading';
};

export const buildPagesById = (
  slots: (PageWindowSlot & { query: PageWindowQuery })[],
): PagesById => {
  const pagesById: PagesById = new Map();

  for (const slot of slots) {
    if (!slot.isValid) {
      continue;
    }

    pagesById.set(slot.page, { status: toSlotStatus(slot.query), data: slot.query.data });
  }

  return pagesById;
};
